import { ObjectTypes } from '@fi-shared/types';
import { FiDateTimeFormatOptions } from '@fi-shared/utils';
import { AccessRightFilterCollectionModel, ILightWeightUser } from './access-right-filter-collection.model';
import { ITextEditorLinkAttachment } from '@fi-shared/fi-text-editor/fi-text-editor';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class PostModel {
    Id: number;
    ParentId: number;
    IsForumPost: boolean;
    ForumId: number = null;
    Title: string;
    Content: string;
    UserLikesCount: number;
    LikeUsers: any[];
    ChildPosts: any[];
    Links: ITextEditorLinkAttachment[];
    Likes;
    MediaBankFileReferences: IMediaBankFileReference[];
    AccessRightFilterCollection: AccessRightFilterCollectionModel;
    CreatedOn;
    ChangedOn;
    ChangedOnDateTime: string;
    CreatedByUserId: number;
    ChangedByUserId: number;
    ChangedByUserName: string;
    CreatedByUserName: string;
    TaggedUsers: ILightWeightUser[] = [];

    constructor(fiFormatDateService: FiFormatDateService, post?: PostModel, isForumPost?: boolean) {
        this.Reset(fiFormatDateService);
        this.Initialize(post, fiFormatDateService);
        this.IsForumPost = !!isForumPost;
    }

    Reset(fiFormatDateService: FiFormatDateService) {
        this.Id = 0;
        this.ParentId = undefined;
        this.Content = '';
        this.UserLikesCount = 0;
        this.LikeUsers = [];
        this.ChildPosts = [];
        this.Links = [];
        this.MediaBankFileReferences = [];
        this.AccessRightFilterCollection = new AccessRightFilterCollectionModel();
        //this.AccessRightFilterCollection.SelectionMode = AccessRightTabs.QuickChoice;
        this.CreatedOn = new Date();
        this.ChangedOn = new Date();
        this.ChangedOnDateTime = fiFormatDateService.formatDate(this.ChangedOn, FiDateTimeFormatOptions);
    }

    Initialize(post, fiFormatDateService: FiFormatDateService) {
        if (post) {
            this.Id = post.Id;
            this.ParentId = post.ParentId;
            this.Content = post.Content;
            this.UserLikesCount = post.UserLikesCount;
            this.LikeUsers = post.LikeUsers;
            this.ChildPosts = post.ChildPosts;
            this.CreatedByUserId = post.CreatedByUserId;
            this.CreatedByUserName = post.CreatedByUserName;
            this.CreatedOn = post.CreatedOn;
            this.ChangedByUserId = post.ChangedByUserId;
            this.ChangedByUserName = post.ChangedByUserName;
            this.ChangedOn = post.ChangedOn;
            this.ChangedOnDateTime = fiFormatDateService.formatDate(this.ChangedOn, FiDateTimeFormatOptions);
            this.MediaBankFileReferences = post.MediaBankFileReferences;
            this.Links = post.Links;
            this.TaggedUsers = post.TaggedUsers;

            if (post.AccessRightFilterCollection) {
                this.AccessRightFilterCollection.InitializeAccessRightFilterCollection(
                    post.AccessRightFilterCollection,
                );
            }

            this.ForumId = post.ForumId;
        }
    }

    GetObjectType() {
        return this.ForumId ? ObjectTypes.ForumPost : ObjectTypes.Post;
    }
}
